module.exports = __webpack_public_path__ + "img/foto-hold-paper.a25b3e33.png";